import { useFragment } from '@apollo/client/react';
import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { AddMetadataLabelFragmentFragmentDoc } from './AddMetadataLabelFragment.gql';
import { RemoveSelection } from './RemoveSelection';
import { SubmitSelection } from './SubmitSelection';
export function AddMetadataNumberSelection(props) {
    const { from } = props;
    const [field, , helpers] = useField('value');
    const { data, complete } = useFragment({
        from,
        fragment: AddMetadataLabelFragmentFragmentDoc,
    });
    const handleOnChange = (str) => {
        const numberValue = parseInt(str, 10);
        if (Number.isNaN(numberValue)) {
            return;
        }
        helpers.setValue(numberValue);
    };
    if (!complete) {
        return null;
    }
    return (<Menu.ItemNested target={data.label}>
      <Menu.HeaderInput type="number" value={`${field.value}`} onChange={handleOnChange} placeholder={t({
            message: 'Enter a number...',
            comment: 'Metadata: Add metadata number pair - Input placeholder',
        })}/>
      <SubmitSelection />
      <RemoveSelection />
    </Menu.ItemNested>);
}
